export default __webpack_public_path__ + "static/media/diego-peretti-3.fbb41e15.webp";